import React from 'react'
import {brandOptions} from './options'
import {inputMessage} from './input-message'

const brandInputMessage = (brand, category, division, prefix) => {
  return inputMessage(brand, brandOptions, category, division, prefix)
}

export {brandInputMessage}
